var Marionette = require('backbone.marionette');

var ReviewerSelectView = require('../review/reviewers-items-select');
var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');
var PasswordConfirmation = require('./password-confirmation');

var EntityModel = require('../../models/entity-model');

var CommonUtils = require('../../utils/common-utils.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var DocumentReviewersView = Marionette.View.extend({
    template: require('../../templates/documents/document-reviewers.html'),

    regions: {
        passwordConfirmationDiv: '.password-confirmation-div',
        obsoleteConfirmationModal: '#obsolete-confirmation-modal'
    },

    events: {
        'click #sign': 'setStatusToSignOrView',
        'click #delete': 'setStatusToDelete',
        'click .reassign-person': 'assignPerson',
        'click .assign-person': 'assignPerson',
        'click .reassign-organization': 'assignOrganization',
        'click .assign-organization': 'assignOrganization'
    },

    ui: {
        changeReviewerModal: '#changeReviewerModal'
    },

    childViewEvents: {
        'action:confirmed': 'onConfirmed'
    },

    initialize: function (options) {
        _.bindAll(this, 'changeStatus', 'canUserChangeStatus', 'setStatusToSignOrView', 'setStatusToDelete', 'changeStatusAction', 'canChangeReviewer',
            'assignOrganization', 'assignPerson', 'assignReviewer', 'renderSignedByPersonNameAsync', 'onConfirmed');
        this.reviewers = options.reviewers;
        this.documentId = options.documentId;

        this.elementStatuses = options.elementStatuses;
        this.idNamesMap = options.idNamesMap;

        this.permissions = options.permissions || [];
        this.relations = options.relations || [];

        this.utils = new CommonUtils();
        this.canEdit = options.canEdit;
        this.canUploadForOrganizationInDocument = options.canUploadForOrganizationInDocument;
        this.byAdmin = options.byAdmin;
    },

    onRender: function() {
        this.obsoleteReviewerConfirmationModal =
            new YesNoConfirmationModal({
                message: 'You are going to obsolete this reviewer. Are you sure?',
                tag: 'obsolete-reviewer'
            });
        this.showChildView('obsoleteConfirmationModal', this.obsoleteReviewerConfirmationModal);
    },

    templateContext: function () {
        var that = this;
        return {
            reviewers: that.reviewers,
            getReviewerStatusText: that.utils.getReviewerStatus,
            elementStatuses: that.elementStatuses,
            //getName: function (id) {
            //    return that.idNamesMap[id];
            //},
            getName: function (id, uid) {
                var idNamesMap = {};
                that.relations.forEach(function (relation) {
                    idNamesMap[relation.child.id] = relation.child.name;
                });
                if (_.contains(_.keys(idNamesMap), id))
                    return idNamesMap[id];
                else
                    that.renderSignedByPersonNameAsync(id, uid);
            },
            canUserChangeStatus: that.canUserChangeStatus,
            canEdit: function () {
                return that.canEdit();
            },
            canUploadForOrganizationInDocument: function () {
                return that.canUploadForOrganizationInDocument();
            },
            canChangeReviewer: that.canChangeReviewer,
            //persons: that.persons,
            changeReviewer: that.changeReviewer,
            byAdmin: that.byAdmin,
            fmtTime: function(timeAsLong) {
                return that.utils.longToDateTimeFormatted(timeAsLong, "MM/DD/YYYY hh:mm A");
            }
        }
    },

    canUserChangeStatus: function (reviewer) {
        return this.utils.canUserChangeStatus(this.permissions, reviewer);
    },

    changeStatus: function (event) {
        this.changeStatusAction($(event.target).attr('uid'), $(event.target).attr('value'));
    },

    setStatusToSignOrView: function (event) {
        if ($(event.target).attr('data-value') == 'true') {
            var passwordConfirmation = new PasswordConfirmation({
                action: this.changeStatusAction,
                id: $(event.target).attr('uid')
            });
            this.showChildView('passwordConfirmationDiv', passwordConfirmation);
            passwordConfirmation.showPasswordConfirmation();
        }
        else
            this.changeStatusAction($(event.target).attr('uid'), 'VIEWED');
    },

    setStatusToDelete: function (event) {
        var that = this;
        this.obsoleteReviewerConfirmationModal.show();
        this.callback = function() {
            that.changeStatusAction($(event.target).attr('uid'), 'DELETED');
        }
    },

    changeStatusAction: function (uid, value, password) {
        var that = this;
        that.utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/document/' + this.documentId + '/element/' + uid + '/status/' + value,
            data: password,
            contentType: 'text/plain',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    that.triggerMethod('review:status:updated', response);
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },
    canChangeReviewer: function (reviewer) {
        var organizationId = reviewer.organizationId;
        var personId = this.permissions.userId;
        return this.utils.userCanDo(
            this.permissions,
            function (permission) {
                return permission.canChangeReviewer;
            },
            [{
                organizationId: organizationId,
                ownerId: personId
            }],
            function (permission) {
                return true;
            });
    },

    assignPerson: function (event) {
        this.assignReviewer(event, true);
    },

    assignOrganization: function (event) {
        this.assignReviewer(event, false);
    },

    assignReviewer: function(event, isReviewerPerson) {
        var that = this;
        var uid = $(event.target).attr('uid');
        var reviewer = that.reviewers.find(function (reviewer) {
            return reviewer.uuid == uid;
        });
        var reviewerId = isReviewerPerson ? reviewer.personId : reviewer.organizationId;
        var perSelect = new ReviewerSelectView({
            el: this.$('#' + uid + reviewerId),
            isReviewerPerson: isReviewerPerson,
            selectedEntity: reviewerId,
            reviewer: _.clone(reviewer),
            documentId: that.documentId,
            onSave: function (response) {
                if (response)
                    that.reviewers = response.object.reviewers;
                that.relations = response.relations;
                that.render();
            },
            onCancel: function () {
                that.render();
            }
        });
        perSelect.render();
    },

    renderSignedByPersonNameAsync: function(id, uid) {
        var that = this;
        var model = new EntityModel({
            id: id
        });
        model.fetch({
            success: function () {
                $('#' + uid + id + ' > a').text(model.get('name'));
            },
            error: function () {
            }
        });
    },

    onConfirmed: function(data) {
        var that = this;
        if (data.result == true && data.tag === "obsolete-reviewer") {
            that.callback();
        }
    }
});

module.exports = DocumentReviewersView;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/document-reviewers-view.js
// module id = 404
// module chunks = 0